import Lamina01Portada from "./Lamina01Portada";
import Lamina02TorresEjecutivas from "./Lamina02TorresEjecutivas";
import Lamina03Crecimiento from "./Lamina03Crecimiento";

// Lista de láminas del mediakit, en orden. Cada fase suma las que corresponda
// (ver docs/componentes/mediakit-v2.md). `columnas`: centros de columna (% del ancho de la lámina)
// que el modo guía (?guias=1) superpone — solo para verificar a ojo, opcional por lámina.
export const LAMINAS = [
  { id: "portada", label: "Portada", Component: Lamina01Portada, columnas: [] },
  {
    id: "torres-ejecutivas",
    label: "Torres Ejecutivas",
    Component: Lamina02TorresEjecutivas,
    columnas: [25, 75],
  },
  {
    id: "crecimiento",
    label: "Constante Crecimiento",
    Component: Lamina03Crecimiento,
    columnas: [23.75, 73.75],
  },
];
